<template>
  <div class="container mt-10">
    <loading v-model:active="isLoading" :can-cancel="true" :on-cancel="onCancel" :is-full-page="fullPage" />
    <header class="header">
      <section class="header-content" v-if="!isLoading">
        <div class="header-content-box d-flex align-items-center" v-if="pirates && pirates.length > 0">
          <div class="header-img me-3">
            <img src="/lostsailor/images/pirate-icon.jpeg" alt="pirate" class="img-fluid" />
          </div>

          <span class="text-capitalize">Pirates:</span>
          <span class="ms-1 font-weight-bold"> {{ pirates.length }}</span>
        </div>

        <div class="header-content-box d-flex align-items-center">
          <div class="header-img me-3">
            <img src="/lostsailor/images/ship-wheel.png" alt="explorer" class="img-fluid" />
          </div>
          <span class="text-capitalize">Joined:</span>
          <span class="ms-1 font-weight-bold">
            {{ division.participants }}</span>
        </div>
        <div class="header-content-box d-flex align-items-center">
          <div class="header-img me-3">
            <img src="/lostsailor/images/coin.png" alt="explorer" class="img-fluid" />
          </div>
          <span class="text-capitalize">Cost:</span>
          <span class="ms-1 font-weight-bold">
            {{ parseFloat(division.fee) }}</span>
        </div>
        <div class="header-content-box d-flex align-items-center" v-if="explorers && explorers.length > 0">
          <div class="header-img me-3">
            <img src="/lostsailor/images/ship-wheel.png" alt="explorer" class="img-fluid" />
          </div>
          <span class="text-capitalize">Explorer:</span>
          <span class="ms-1 font-weight-bold"> {{ explorers.length }}</span>
        </div>
      </section>
    </header>
    <div class="main-attack-section">
      <h1 class="attack-title">Attack</h1>
      <br>
      <i class="fas fa-sync text-white fa-lg cursor-pointer" @click="init(null)"></i>
      <div class="content-body">
        <section class="account--type">
          <div class="account-name d-flex justify-content-around">
            <h3 class="py-2">Pirates</h3>
            <h3 class="py-2">Explorers</h3>
          </div>
        </section>
        <div class="scroll px-3">
          <div class="row">
            <div class="col-md-6" v-if="pirates && pirates.length > 0">
              <section class="content-wrapper" v-for="(item, index) in pirates" :key="index">
                <div class="attack-userImg">
                  <img src="images/gg_profile.png" alt="" />
                </div>
                <div class="account-info">
                  <h4 class="username">
                    <span>{{ item.account }}</span>
                    <i class="fas fa-paw text-white" v-if="item.pet!=0"></i>
                  </h4>
                  <h4 class="total-reward" v-if="item.started"><i class="fas fa-check text-white"></i></h4>
                  <h4 class="total-reward text-danger" v-if="item.started==0" @click="attack(myRec[0].division_id)">Not
                    Joined</h4>
                </div>
              </section>
            </div>
            <div class="col-md-6" v-else>
              <section class="content-wrapper">
                <h4 class="username p-2">No user yet</h4>
              </section>
            </div>
            <div class="col-md-6" v-if="explorers && explorers.length > 0">
              <section class="content-wrapper" v-for="(item, index) in explorers" :key="index">
                <div class="attack-userImg">
                  <img src="images/gg_profile.png" alt="" />
                </div>
                <div class="account-info">
                  <h4 class="username">
                    <span>{{ item.account }}</span>
                    <i class="fas fa-paw text-white" v-if="item.pet!=0"></i>
                  </h4>
                  <!-- <h4 class="total-reward">{{ parseInt(item.power) }}</h4> -->
                  <h4 class="total-reward" v-if="item.started"><i class="fas fa-check text-white"></i></h4>
                  <h4 class="total-reward text-danger" v-if="item.started==0" @click="attack(myRec[0].division_id)">Not
                    Joined</h4>
                </div>
              </section>
            </div>
            <div class="col-md-6" v-else>
              <section class="content-wrapper">
                <h4 class="username p-2">No user yet</h4>
              </section>
            </div>
          </div>
        </div>
      </div>

      <div class="back">
        <router-link to="/dashboard">
          <i class="fa fa-angle-left text-white" aria-hidden="true"></i>
        </router-link>
      </div>
    </div>
    <section class="attack-info" v-if="!isLoading">
      <div class="info-content" v-if="myRec.length">
        <section class="inner-content">
          <span class="ms-2">{{ myRec[0].account }}</span>
        </section>
        <section class="inner-content">
          <span>Power :</span>
          <span class="ms-1"><strong>{{ myRec[0].power }}</strong></span>
        </section>
        <section class="inner-content">
          <span>Cost :</span>
          <span class="ms-1" v-if="division"><strong>{{ parseFloat(division.fee) }} DOUB</strong></span>
        </section>
        <section class="inner-content">
          <span>Division :</span>
          <span class="ms-1" v-if="!division"><strong>{{ myRec[0].division_id }}</strong></span>
          <span class="ms-1" v-if="division"><strong>{{ division.title }}</strong></span>
        </section>
        <section class="inner-content">
          <button class="btn btn-white mr-10" @click="attack(myRec[0].division_id)">
            Attack
          </button>
          <button class="btn btn-danger" @click="cancel()">Cancel</button>
        </section>
      </div>
      <div v-else>
        <div class="info-content" v-if="division">
          <section class="inner-content">
            <span class="ms-2">{{ division.title }}#{{ division.id }}</span>
          </section>
          <section class="inner-content">
            <span>Can Participate :</span>
            <span class="ms-1"><strong>{{ division.allowed_users }}</strong></span>
          </section>
          <section class="inner-content">
            <span>Accouncement at :</span>
            <span class="ms-1" v-if="division"><strong>{{ division.start_at }}:00</strong></span>
          </section>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import ApiService from "../services";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { useToast } from "vue-toastification";
const toast = useToast();
import { mapGetters } from "vuex";
var allRec = [];
export default {
  name: "LeaderBoard",
  components: {
    Loading,
  },
  computed: {
    ...mapGetters(["division"]),
  },
  data() {
    return {
      error: false,
      searchTerm: "",
      isLoading: false,
      fullPage: true,
      more: false,
      next_key: false,
      myRec: [],
      info: null,
      explorers: null,
      pirates: null,
    };
  },
  mounted() {
    this.init(null);
  },
  methods: {
    async init() {
      this.isLoading = true;
      allRec = [];
      return await ApiService.getTableAll(
        "battle.users",
        async (result) => {
          if (result.rows.length > 0) {
            if (allRec) {
              allRec = [...new Set([...result.rows, ...allRec])];
            } else {
              allRec = result.rows;
            }
            allRec.sort((a, b) => (Number(a.power) > Number(b.power) ? -1 : 1));
            const or = allRec.slice(0, 50);
            this.myRec = or.filter(
              (i) =>
                i.account == localStorage.getItem("wax_user") && i.started == 0
            );
            this.explorers = or.filter((i) => i.team == "Explorers");
            this.pirates = or.filter((i) => i.team == "Pirates");
            if (this.myRec.length > 0) {
              this.$store.dispatch("getDivision", this.myRec[0]).then(() => {
                this.isLoading = false;
              });
            } else {
              this.$store.dispatch("getDivision", or[0]).then(() => {
                this.isLoading = false;
              });
            }
          } else {
            this.$router.push("battle");
          }
          return result;
        },
        (error) => {
          this.isLoading = false;
          toast.error(error);
        }
      );
    },
    async cancel() {
      ApiService.transaction(
        {
          action: "rmbattle",
          contract: process.env.VUE_APP_CONTRACT,
          data: {
            account: localStorage.getItem("wax_user"),
          },
        },
        (res) => {
          if (res.processed) {
            toast.success("Battle removed...");
            this.$router.go("/battle");
          }
        }
      );
    },
    async attack() {
      await this.init(null);
      const myAttak = this.myRec[0];
      if (myAttak && myAttak.division_id) {
        await ApiService.buy(
          {
            from: localStorage.getItem("wax_user"),
            to: process.env.VUE_APP_CONTRACT,
            quantity: this.division.fee,
            memo: `attack:${myAttak.division_id}`,
          },
          (res) => {
            if (res.processed) {
              toast.success("Attack has been done.");
              this.$router.go("/");
            }
          },
          (error) => {
            error = ApiService.errorFormat(error);
            toast.error(error);
          }
        );
      } else {
        this.error = "Refresh the page, seems like the attack time ended.";
        toast.error(this.error);
      }
    },
  },
};
</script>
<style scoped>
.loadmore {
  width: 200px;
  border: 1px solid #fff;
  padding: 5px;
  border-radius: 5px;
  margin-top: 10px;
  font-weight: bold;
}
.header {
  margin-bottom: 40px;
}
.header-content {
  width: 50%;
  margin: auto;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.header .header-img {
  width: 50px;
  height: 50px;
  border-right: 1px solid white;
  padding: 3px;
}
.header .header-img img {
  height: 100%;
  float: left;
}

.header-content-box {
  border: 1px solid #fff;
  padding: 0 11px 0 4px;
  border-radius: 10px;
  margin-right: 65px;
}

.main-attack-section {
  height: 82%;
  margin: auto;
  width: 75%;
  background: #1a203c;
  border: 3px solid var(--offWhite);
  text-align: center;
  box-sizing: border-box;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 37px;
}

.attack-title {
  background: var(--primaryColor);
  color: var(--mainWhite);
  text-transform: uppercase;
  box-sizing: border-box;
  text-align: center;
  display: inline-block;
  font-size: inherit;
  font-weight: bold;
  font-size: 30px;
  padding: 2px 30px;
  margin-top: -20px;
  border: 4px solid var(--mainWhite);
  border-radius: 8px;
}

.content-body {
  padding: 3px 12px;
  display: flex;
  /* justify-content: center; */
  /* align-items: center; */
  flex-direction: column;
}

.content-wrapper {
  display: flex;
  align-items: center;
  border: 1px solid var(--mainWhite);
  border-radius: 15px;
  margin-bottom: 10px;
}

.leaderBoard-reward {
  margin-right: 10px;
}

.leaderBoard-reward h6 {
  font-size: 0.8rem;
  text-transform: uppercase;
  font-weight: bold;
}

.leaderBoard-reward img {
  width: 40px;
  height: 40px;
}

.attack-userImg {
  padding-left: 5px;
}
.attack-userImg img {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.account-info {
  background: linear-gradient(to left, #233275 100%, #00a3ff 28%);
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 54px;
  padding: 14px;
  border-radius: 0 15px 15px 0;
  margin-left: 10px;
  box-shadow: var(--lightShadow);
  border-left: 2px solid wheat;
}

.account-info .username,
.total-reward {
  color: var(--mainWhite);
  font-size: 18px;
  margin-top: 6px;
  text-transform: capitalize;
}
.account-info .paw-icon {
  width: 40px;
  height: 40px;
  display: inline-block;
}

.leaderBoard-reward h4 {
  color: var(--mainWhite);
  font-size: 18px;
  width: 40px;
  text-align: center;
}

.main-attack-section .back {
  text-align: right;
  margin-right: 1rem;
  font-size: 2.22rem;
  color: var(--mainWhite);
}

.btn {
  padding: 6px 30px;
  font-size: 24px;
  border-radius: 40px;
  text-transform: uppercase;
  font-weight: bold;
}

.attack-info {
  width: 75%;
  margin: 20px auto;
  border: 2px solid #fff;
  border-radius: 20px;
}
.info-content {
  padding: 7px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.inner-content img {
  width: 50px;
  height: 50px;
}
.inner-content span {
  font-size: 20px;
}
.mr-10 {
  margin-right: 10px;
}
</style>